export const appConstants = {
  SET_SITE_SETTINGS_SUCCESS: 'APP_SET_SITES_SETTINGS_SUCCESS',
  SET_SITE_SETTINGS_FAILURE: 'APP_SET_SITES_SETTINGS_FAILURE',

  SET_OFFERS_SETTINGS_SUCCESS: 'APP_SET_OFFERS_SETTINGS_SUCCESS',
  SET_OFFERS_SETTINGS_FAILURE: 'APP_SET_OFFERS_SETTINGS_FAILURE',

  SET_GLOBAL_SETTINGS_SUCCESS: 'APP_SET_GLOBAL_SETTINGS_SUCCESS',
  SET_GLOBAL_SETTINGS_FAILURE: 'APP_SET_GLOBAL_SETTINGS_FAILURE',

  SET_AUTH_SETTINGS_SUCCESS: 'APP_SET_AUTH_SETTINGS_SUCCESS',
  SET_AUTH_SETTINGS_FAILURE: 'APP_SET_AUTH_SETTINGS_FAILURE',
  RECAPTCHA_LOADING_SUCCESS: 'RECAPTCHA_LOADING_SUCCESS',
};
